// @ts-strict
import { Injectable } from '@angular/core';
import { LMBrowserUtilService } from '@utils/lm-browser-util.service';

export enum LMKeyType {
  SAVE = 'Save',
  REFRESH = 'Refresh',
  PREVIOUS = 'Previous',
  NEXT = 'Next',
  MENU = 'MenuToggle',
  DEFINE = 'Define',
  OPEN = 'Open',
  FIELDOPTION = 'FieldOption'
}

@Injectable()
export class LMKeyboardShortcutService {

  constructor(
    private lmBrowserUtilService: LMBrowserUtilService
  ) {
    // no op
  }

  public onKeyDown(event: any): LMKeyType | null {
    // event.metaKey is mac command key

    // keyCode 75 = k or K
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.keyCode === 75) {
      if (this.lmBrowserUtilService.isEdge) {
        event.preventDefault();
      }
      return LMKeyType.MENU;
    }

    // keyCode 37 = LeftArrow or Left
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.keyCode === 37) {
      return LMKeyType.PREVIOUS;
    }

    // keyCode 39 = RightArrow or Right
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.keyCode === 39) {
      return LMKeyType.NEXT;
    }

    // keyCode 83 = s or S
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.keyCode === 83) {
      if (this.lmBrowserUtilService.isEdge || this.lmBrowserUtilService.isSafari) {
        event.preventDefault();
      }
      return LMKeyType.SAVE;
    }

    // keyCode 116 = F5
    if ((this.lmBrowserUtilService.isMAC && event.keyCode === 116)
    || (event.ctrlKey && event.shiftKey && event.keyCode === 116)) {
      return LMKeyType.REFRESH;
    }

    // keyCode 117 = F6
    if ((this.lmBrowserUtilService.isMAC && event.keyCode === 117)
    || (event.ctrlKey && event.shiftKey && event.keyCode === 117)) {
      return LMKeyType.DEFINE;
    }

    // keyCode 79 = O or o
    if ((event.ctrlKey || event.metaKey) && event.altKey && (event.keyCode === 79)) {
      return LMKeyType.OPEN;
    }

    //keyCode 118 = F7
    if ((this.lmBrowserUtilService.isMAC && event.keyCode === 118)
      || (event.ctrlKey && event.shiftKey && event.keyCode === 118)) {
      return LMKeyType.FIELDOPTION;
    }

    return null;
  }
}
